import(/* webpackMode: "eager" */ "D:\\dev\\project\\bigtv_next\\app\\error.tsx");
